import React from 'react';
import {Stack, useTheme} from '@mui/material';
import Icon from 'presentation/icons';
import {translations} from 'presentation/translations-new';
import {formatPriceRefund} from 'presentation/utils';
import type {ProtocolItemHeaderProps} from './types';
import {
	InlineLabelStack,
	ProtocolItemHeaderContainer,
	Label,
	StyledRadio,
	TitleTypography,
	Value,
} from './styles';

const {
	requestedAt: requestedAtLabel,
	valueInformed: valueInformedLabel,
} = translations['pt-br'].privateFlow.refund.additionalDocuments.searchProtocol.protocolItemAccordion;

export function ProtocolItemHeader({
	title,
	requestedAt,
	valueInformed,
	isRefund,
	selected,
	onSelect,
	error,
}: ProtocolItemHeaderProps) {
	const theme = useTheme();
	const secondaryColor = theme.palette.text.secondary;

	return (
		<ProtocolItemHeaderContainer>
			{!isRefund ? (
				<StyledRadio
					checked={selected}
					color={error ? 'error' : 'primary'}
					sx={error ? {color: theme => theme.palette.error.main} : undefined}
					onChange={e => {
						e.stopPropagation();
						onSelect?.();
					}}
					onClick={e => e.stopPropagation()}
				/>
			) : null}
			<Stack minWidth={0} pt="8px" gap="4px">
				<TitleTypography variant="subtitle1" fontWeight={400}>
					{title}
				</TitleTypography>
				<Stack gap={0}>
					<Stack direction="row" alignItems="center" gap="4px">
						<Icon name="event-filled" size={16} color={secondaryColor} />
						<InlineLabelStack>
							<Label variant="body2">{requestedAtLabel}</Label>
							<Value variant="body2">{requestedAt}</Value>
						</InlineLabelStack>
					</Stack>
					<Stack direction="row" alignItems="center" gap="4px">
						<Icon name="paid" size={16} color={secondaryColor} />
						<InlineLabelStack>
							<Label variant="body2">{valueInformedLabel}</Label>
							<Value variant="body2">{formatPriceRefund(valueInformed)}</Value>
						</InlineLabelStack>
					</Stack>
				</Stack>
			</Stack>
		</ProtocolItemHeaderContainer>
	);
}
